import { render } from "./ModalHistoricSite.vue?vue&type=template&id=8a505d04&ts=true"
import script from "./ModalHistoricSite.vue?vue&type=script&lang=ts"
export * from "./ModalHistoricSite.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__